import { c as _c } from "react/compiler-runtime";
import { forwardRef } from 'react';
import { getSpartanLineupModelCardSurfaceClassName } from '@/app/lcv/components/sections/spartan/shared/lineup/carousel/model-card/styles';
import styles from '@/app/lcv/components/sections/spartan/shared/lineup/styles.module.css';
import type { SpartanLineupStyleName, SpartanLineupTone } from '@/app/lcv/components/sections/spartan/shared/lineup/types';
import { cn } from '@/app/utils/cn';
export const SpartanLineupModelCardLightSurface = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="bg-silver-100 pointer-events-none absolute inset-x-0 top-0 bottom-0 rounded-lg" aria-hidden={true} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export const SpartanLineupModelCardDarkSurface = t0 => {
  const $ = _c(5);
  const {
    tone,
    styleName
  } = t0;
  let t1;
  if ($[0] !== styleName || $[1] !== tone) {
    t1 = cn("pointer-events-none absolute inset-x-0 -top-20 bottom-0 z-0 rounded-lg", getSpartanLineupModelCardSurfaceClassName({
      tone,
      styleName
    }));
    $[0] = styleName;
    $[1] = tone;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <div className={t1} aria-hidden={true} />;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export const SpartanLineupModelCardHoverBorder = forwardRef<HTMLDivElement, {
  tone: SpartanLineupTone;
  styleName?: SpartanLineupStyleName;
}>(function SpartanLineupModelCardHoverBorder(t0, ref) {
  const $ = _c(5);
  const {
    tone,
    styleName
  } = t0;
  const isDark = tone === "dark";
  const borderClassName = !isDark ? styles.modelCardBorderLight : styleName === "x-series" ? styles.modelCardBorderDarkFull : styles.modelCardBorderDark;
  let t1;
  if ($[0] !== borderClassName) {
    t1 = cn(styles.modelCardBorder, borderClassName);
    $[0] = borderClassName;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== ref || $[3] !== t1) {
    t2 = <div ref={ref} aria-hidden={true} className={t1} />;
    $[2] = ref;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
});